<script lang="ts">
import { createContext } from 'reka-ui'
import { type ComputedRef } from 'vue'

export const [useSidebar, provideSidebar] = createContext<{
  isRail: ComputedRef<boolean>
  toggleRail: () => void
}>('gat-ship-sidebar-provider')
</script>
<script setup lang="ts">
import { computed } from 'vue'

const isRail = defineModel<boolean>('isRail', { required: false, default: false })

function toggleRail() {
  isRail.value = !isRail.value
}

provideSidebar({
  isRail: computed(() => isRail.value),
  toggleRail
})
</script>
<template>
  <slot :isRail="isRail" :toggleRail="toggleRail" />
</template>
